import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './http';

/**
 * Não adianta repetir erro do cliente (4xx), resposta fora do contrato (`bad_response`: chega com
 * o status 200 e é determinística) nem tempo esgotado (`timeout`: repetir triplicaria a espera).
 * Rede fora do ar e 5xx merecem até 2 novas tentativas.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error)) {
    if (error.code === 'bad_response' || error.code === 'timeout') return false;
    if (error.status >= 400 && error.status < 500) return false;
  }
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        // `networkMode: 'always'`: com o navegador offline o padrão ('online') NÃO tenta a
        // requisição e deixa a consulta "pausada": a tela fica num esqueleto eterno, sem erro nem
        // "Tentar de novo". Tentando de verdade o `fetch` falha na hora e o erro de rede (em
        // português) aparece. Vale também para a sessão (AuthProvider herda estes padrões).
        networkMode: 'always',
        // Explícito porque, no modo 'always', o padrão do React Query vira `false`: sem isto a lista
        // que falhou por falta de internet ficaria no erro mesmo depois de a rede voltar.
        refetchOnReconnect: true,
      },
      // Mesmo motivo: uma mutação offline deve falhar (e a tela avisar), não esperar em silêncio.
      mutations: { retry: false, networkMode: 'always' },
    },
  });
}
